export default "__VITE_ASSET__DP3GZ1Ks__"